import React, { useState, useEffect, useRef } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { FileHiddenInput, Image } from "hesus-ui-kit";
import addIcon from "@icons/ic-add-green.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import { ColumnButton } from "@utils/extra-style";
import { documentTypeColor, documentName } from "@utils/constants";
import {
  FileInputLabel,
  FileImageWrapper,
  DocumentRow,
  FileName,
  DeleteSpan,
  DocumentDropdown,
  GridRow,
} from "./DocumentUpload.styled";

const MultilineDocumentUploadWithType = (props) => {
  const {
    t,
    isEditMode,
    onDocumentUpload,
    existingDocuments,
    documentTypeOptions,
    summaryIndex,
    mainIndex,
    newDocument,
    onDeleteDocument,
    documentTypes,
  } = props;
  const fileInputRef = useRef();
  const [displayDropdown, setDisplayDropdown] = useState(false);

  const documentListRef = useRef();

  const uploadDropdownToggle = () => {
    setDisplayDropdown(!displayDropdown);
  };

  useEffect(() => {
    if (displayDropdown) {
      documentListRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [displayDropdown]);

  const triggerUploadInput = (type) => {
    fileInputRef.current.setAttribute("data-type", type);
    fileInputRef.current.click();
  };

  const onFileSelect = (e) => {
    uploadDropdownToggle();
    onDocumentUpload(e, mainIndex, summaryIndex);
  };

  const deleteFile = (id) => {
    onDeleteDocument(mainIndex, summaryIndex, id, "deleteNewDocument");
  };

  const deleteExistingFile = (id) => {
    onDeleteDocument(mainIndex, summaryIndex, id, "deleteExisting");
  };

  const getDocumentList = (files) => {
    let docs = [];
    for (let i = 0; i < files.length; i++) {
      docs[i] = (
        <DocumentRow key={i} marginTop="10px">
          <FileName top="0px">
            <DeleteSpan>
              {" "}
              <Image
                className="deleteImage"
                src={deleteIcon}
                alt="delete"
                onClick={() => deleteFile(i)}
                styles={{ width: "auto" }}
              />
              <ColumnButton
                border={documentTypeColor[documentTypes[i]]}
                background={documentTypeColor[documentTypes[i]]}
                marginRight="10px"
                marginLeft="10px"
              >
                <span>{t(documentName[documentTypes[i]])}</span>
              </ColumnButton>
            </DeleteSpan>{" "}
            {files[i].name}
          </FileName>
        </DocumentRow>
      );
    }
    return docs;
  };

  const getExistingDocumentList = (files) => {
    let docs = [];
    for (let i = 0; i < files.length; i++) {
      docs[i] = (
        <DocumentRow key={i} marginTop="10px">
          <FileName top="0px">
            <DeleteSpan>
              {" "}
              <Image
                className="deleteImage"
                src={deleteIcon}
                alt="delete"
                onClick={() => deleteExistingFile(files[i].id)}
                styles={{ width: "auto" }}
              />
              <ColumnButton
                border={documentTypeColor[files[i].type.id]}
                background={documentTypeColor[files[i].type.id]}
                marginRight="10px"
                marginLeft="10px"
              >
                <span>{t(documentName[files[i].type.id])}</span>
              </ColumnButton>
            </DeleteSpan>{" "}
            {files[i].fileName}{" "}
          </FileName>
        </DocumentRow>
      );
    }
    return docs;
  };

  return (
    <>
      <GridRow column="auto 1fr">
        <div style={{ marginBottom: "0px" }}>
          <FileInputLabel>{t("DOCUMENTS")}</FileInputLabel>

          <FileImageWrapper>
            <Image
              src={addIcon}
              alt="upload"
              displayDropdown={displayDropdown}
              onClick={uploadDropdownToggle}
              styles={{ width: "auto" }}
            />
          </FileImageWrapper>

          {displayDropdown && (
            <DocumentDropdown position="relative">
              <ul className="document-dropdown-list">
                {documentTypeOptions.map((item) => (
                  <li
                    key={item.id}
                    className="document-upload-list-item"
                    onClick={() => triggerUploadInput(item.id)}
                  >
                    <label className="document-label">{t(item.label)}</label>
                  </li>
                ))}
              </ul>
              <FileHiddenInput
                type="file"
                id="document"
                multiple
                inputClass="document-upload-input-field"
                onFileSelect={onFileSelect}
                fileInputRef={fileInputRef}
              />
            </DocumentDropdown>
          )}
          {/* <FileInput type="file" id="document" multiple onChange={onFileSelect} /> */}
        </div>
      </GridRow>
      <GridRow column="repeat(3, 1fr)" margin="15px 0 0 0">
        {!!existingDocuments &&
          existingDocuments !== undefined &&
          existingDocuments?.length > 0 &&
          getExistingDocumentList(existingDocuments)}
        {!!newDocument &&
          newDocument !== undefined &&
          newDocument.length > 0 &&
          getDocumentList(newDocument)}
        <div ref={documentListRef}></div>
      </GridRow>
    </>
  );
};

MultilineDocumentUploadWithType.propTypes = {
  t: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
  docFromLead: PropTypes.number,
};

MultilineDocumentUploadWithType.defaultProps = {
  isEditMode: false,
  docFromLead: 0,
};

export default withTranslation()(MultilineDocumentUploadWithType);
